/**
 * Loại cột - xác định editor
 */
export default {
  // / Thực chi
  Spend: 1,
  // / Tạm ứng
  Advance: 2,
  // 3. Ứng trước đủ đk thanh toán
  AdvanceQualified: 3,
  // 4. Ứng trước chưa đủ đk thanh toán
  AdvanceNotQualified: 4,
  // / Không chọn
  None: 5,
};
